export const ROUTES = {
	home: "/",
	aboutUs: "/about-us",
	ourServices: "/our-services",
	serviceDetails: "/our-services/services-details",
	portfolio: "/portfolio",
	portfolioDetails: "/portfolio/portfolio-details",
	ourTeam: "/our-team",
	teamDetails: "/our-team/team-details",
	testimonials: "/testimonials",
	faqs: "/faqs",
	pricingPlans: "/pricing-plans",
	ourBlogs: "/our-blogs",
	blogDetails: "/our-blogs/blog-details",
	contactUs: "/contact-us",
	errorPage: "/404",
};
